/*
 * src/components/MessageCenter/MessageCenterColumnCfg.js
 * Description:
 * Copyright (c) 2020 Mark Fehrenbacher
 */
import React from "react";
import { Tooltip } from "antd";
import moment from "moment";

import { DEFAULT_DATE_FORMAT } from "../../utils/util";
import downloadIcon from "../../styles/assets/table-download-icon.svg";

import { messageKey } from "./mock-data";

const emptyValue = "--";

const columnCfg = (pdfClickHandler = Function.prototype) => [
  {
    title: "DATE CREATED",
    dataIndex: "createdAt",
    render: (a) => {
      return <p>{moment(a).format(DEFAULT_DATE_FORMAT)}</p>;
    },
    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    defaultSortOrder: "descend",
  },
  {
    title: "FROM",
    dataIndex: "tenant",
    render: (text) => <p> {text?.name ?? emptyValue} </p>,
    sorter: (a, b) =>
      (a?.tenant?.name ?? "").localeCompare(b?.tenant?.name ?? ""),
  },    
  {
    title: "REFERENCE",
    dataIndex: "transfer",
    render: (text) => <p>{text?.propertyAddress1 ?? emptyValue}</p>,
    sorter: (a, b) =>
      (a?.transfer?.propertyAddress1 ?? "").localeCompare(
        b?.transfer?.propertyAddress1 ?? ""
      ),
  },
  {
    title: "TYPE",
    dataIndex: "type",
    render: (text) => <p>{messageKey[text]}</p>,
    sorter: (a, b) => (a?.type ?? "").localeCompare(b?.type ?? ""),
  },

  {
    title: "DOWNLOAD",
    dataIndex: "messageURL",
    render: (text) => {
      return (
        <Tooltip placement="topLeft" title="Download PDF">
          <span
            data-tooltip
            className="download-icon"
            onClick={() => pdfClickHandler(text)}
          >
            <img
              src={downloadIcon}
              alt="Download PDF"
              style={{ cursor: "pointer" }}
            />
          </span>
        </Tooltip>
      );
    },
  },
];

export default columnCfg;
